'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bestFacebookLocaleFor = undefined;

var _FacebookLocales = require('./FacebookLocales');

exports.bestFacebookLocaleFor = _FacebookLocales.bestFacebookLocaleFor;


// WEBPACK FOOTER //
// ./~/facebook-locales/dist/index.js